import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAppStore } from './store';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import FavoritesPage from './pages/FavoritesPage';
import ProjectAnalysisPage from './pages/ProjectAnalysisPage';
import FeedbackPage from './pages/FeedbackPage';
import PaymentPage from './pages/PaymentPage';
import ServiceTermsPage from './pages/ServiceTermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import ErrorBoundary from './components/common/ErrorBoundary';

function App() {
  const { user, isAuthenticated, initializeAuth, loadFavorites } = useAppStore();

  useEffect(() => {
    // 应用启动时的初始化逻辑
    const initializeApp = async () => {
      console.log('🚀 应用初始化开始...');

      try {
        // 首先初始化认证状态
        const authInitialized = await initializeAuth();

        // 如果用户已登录，延迟加载收藏列表
        if (authInitialized) {
          // 延迟一点时间确保UI已经渲染完成
          setTimeout(async () => {
            try {
              console.log('📚 加载用户收藏列表...');
              await loadFavorites();
            } catch (error) {
              console.error('Failed to load favorites:', error);
            }
          }, 500);
        }

        console.log('✅ 应用初始化完成');
      } catch (error) {
        console.error('❌ 应用初始化失败:', error);
      }
    };

    initializeApp();
  }, []); // 只在组件挂载时执行一次

  return (
    <ErrorBoundary>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/favorites" element={<FavoritesPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/pricing" element={<PaymentPage />} />
          <Route path="/project-analysis/:owner/:repo" element={<ProjectAnalysisPage />} />
          <Route path="/legal/service" element={<ServiceTermsPage />} />
          <Route path="/terms" element={<ServiceTermsPage />} />
          <Route path="/legal/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/legal/refund" element={<RefundPolicyPage />} />
        </Routes>
      </div>
    </ErrorBoundary>
  );
}

export default App;
